import { useMemo } from 'react';

import { useRecoilValue } from 'recoil';

import { useReportsList, type StaticReport } from 'src/app/pages/reports-v2/use-reports-list';

import { searchTermAtom } from './search-term';

type FilteredReports = {
  filteredReports: StaticReport[];
  isLoading: boolean;
};

export function useFilteredReports(): FilteredReports {
  const filter = useRecoilValue(searchTermAtom);

  const { reportsList = [], isLoading } = useReportsList({
    isEnabled: true,
  });

  const filteredReportsList = useMemo(
    () =>
      reportsList.filter((report) => {
        const hasNameMatch = report.ReportName.toLowerCase().includes(filter.toLowerCase());
        return hasNameMatch;
      }),
    [filter, reportsList]
  );

  return { isLoading, filteredReports: filteredReportsList };
}
